import React, { useEffect, useState } from 'react';
import '../styles/sliver.scss';
import $ from 'jquery';

interface Props {
    data: {
        startDate: Date;
        endDate: Date;
        campaign: string;
        location: any;
        type: string;
        testKey: string;
        dataTrigger: string;
        sliver: any;
    }
}

const handleScroll = () => {
    const height = $('#sliver-container').height() || '';
    if (window.scrollY > 400) {
        $('#sliver-container').addClass('fix-sliverbanner');
        $('.nav-container-scrolled').css('top', height);
    } else if (window.scrollY < 401) {
        $('#sliver-container').removeClass('fix-sliverbanner');
        $('.nav-container-scrolled').css('top', '0px');
    }
}

export const MultiSliverBanner = (prop: Props) => {
    const { data } = prop;
    const windowWidth = window.screen.width;
    const [isMobile, setIsMobile] = useState(windowWidth < 767);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', () => setIsMobile(window.screen.width < 767));
        setTimeout(() => {
            const container = document.getElementById('sliver-container') as HTMLElement;
            const component = document.getElementById('sliverComponent') as HTMLElement;
            container.appendChild(component);
        }, 900);

    }, [isMobile]);


    return (
        <div className="sliver-banner sliverBannerComp multiSliverBannerComp" id="sliverComponent">
            {data.sliver.map((item: any, index: number) => <MobileSliver key={index} data={item} trigger={data.dataTrigger} />)}
            {/* {isMobile ?
                data.sliver.map((item: any, index: number) => <MobileSliver index={index} data={item} trigger={data.dataTrigger} />)
                :
                data.sliver.map((item: any, index: number) => <RegSliver index={index} data={item} trigger={data.dataTrigger} />)
            } */}
        </div>
    );
}

const MobileSliver = (props: any) => {
    const { data, trigger } = props;
    const renderHtml = (data: any) => ({ __html: data });
    return (
        <div className={`${data.background} mobile-sliver-unit`}><a  href={data.destinationURL} data-trigger={trigger} dangerouslySetInnerHTML={renderHtml(data.content)} /></div>
    );
}

